import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import { LOCALE_PREFIX } from './constants'

import EntityInformation from './components/EntityInformation'
import CreditInformation from './components/CreditInformation'
import NegativeInformation from './components/NegativeInformation'

import hocConnect from './hocConnect'
import './style.scss'

@hocConnect
export default class Minireport extends Component {
    static propTypes = {
        data: PropTypes.object,
        getMinireport: PropTypes.func.isRequired,
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        isFailed: PropTypes.bool.isRequired,
        isLoaded: PropTypes.bool.isRequired,
        isLoading: PropTypes.bool.isRequired,
    }

    static defaultProps = {
        data: null,
    }

    componentDidMount() {
        const { isLoading, id, getMinireport } = this.props

        if (!isLoading) getMinireport(id)
    }

    renderLoader = () => {
        const { isLoading } = this.props

        if (!isLoading) return null

        return <div className={'minireport-loader'} />
    }

    renderError = () => {
        const { isFailed } = this.props

        if (!isFailed) return null

        return (
            <div className={'minireport-error'}>
                <FormattedMessage id={`${LOCALE_PREFIX}.error`} />
            </div>
        )
    }

    renderMinireport = () => {
        const { isLoading, isLoaded, isFailed, data } = this.props

        if (isLoading || !isLoaded || isFailed || !data) return null

        const showReport = data?.entity?.showReport !== 'N'

        return (
            <div className={'minireport-content'}>
                {showReport ? (
                    <div>
                        <EntityInformation data={data?.entity ?? {}} />
                        <CreditInformation data={data} />
                        <NegativeInformation data={data?.negativeEvents} />
                    </div>
                ) : (
                    <FormattedMessage id={`${LOCALE_PREFIX}.reportNotAllowed`} />
                )}
            </div>
        )
    }

    render() {
        return (
            <div className={'minireport'}>
                {this.renderLoader()}
                {this.renderMinireport()}
                {this.renderError()}
            </div>
        )
    }
}
